import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import checkIcon from "@/assets/Icons/Checkmark.png";
import lightbulbIcon from "@/assets/Icons/Lightbulb.png";
import teamIcon from "@/assets/Icons/Teamwork.png";
import innovatorIcon from "@/assets/Icons/Innovator.png";
import zapIcon from "@/assets/Icons/Zap.png";
import securitylIcon from "@/assets/Icons/Security.png";
import heroBg from "@/assets/hero-bg-new.png";
import innovationBro from "@/assets/Innovation-bro-2.png";
import { AnimatedSection } from "@/components/AnimatedSection";

const AboutPage = () => {
  const { t } = useLanguage();

  const goals = [
    {
      icon: checkIcon,
      title: t.aboutPage.goals.reliability.title,
      description: t.aboutPage.goals.reliability.description,
    },
    {
      icon: lightbulbIcon,
      title: t.aboutPage.goals.simplicity.title,
      description: t.aboutPage.goals.simplicity.description,
    },
    {
      icon: teamIcon,
      title: t.aboutPage.goals.teamwork.title,
      description: t.aboutPage.goals.teamwork.description,
    },
    {
      icon: innovatorIcon,
      title: t.aboutPage.goals.innovation.title,
      description: t.aboutPage.goals.innovation.description,
    },
    {
      icon: zapIcon,
      title: t.aboutPage.goals.efficiency.title,
      description: t.aboutPage.goals.efficiency.description,
    },
    {
      icon: securitylIcon,
      title: t.aboutPage.goals.security.title,
      description: t.aboutPage.goals.security.description,
    },
  ];

  return (
    <main className="min-h-screen">
      <Navigation />

      {/* Hero Section with same background as ChatAssistant */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: `url(${heroBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-background/65 via-background/60 to-background" />
        </div>

        <div className="container px-6 md:px-8 relative z-10">
          <div className="max-w-7xl mx-auto mb-2 animate-fade-in">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div className="text-left space-y-4">
                <h1 className="mb-6 text-4xl md:text-5xl lg:text-6xl font-bold">
                  {t.aboutPage.title}
                </h1>
                <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
                  {t.aboutPage.description1}
                </p>
                <p className="text-lg md:text-xl text-muted-foreground">
                  {t.aboutPage.description2}
                </p>
                <p className="text-lg md:text-xl text-muted-foreground font-medium">
                  {t.aboutPage.description3}
                </p>
              </div>
              <div className="flex justify-center">
                <img 
                  src={innovationBro} 
                  alt="Innovation illustration" 
                  className="w-full max-w-md h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Goals Section (kept separate so hero bg doesn't affect cards) */}
      <AnimatedSection>
        <section className="py-2 md:py-2 bg-background">
          <div className="container px-6 md:px-8">
            {/* Goals Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 max-w-6xl mx-auto">
              {goals.map((goal, index) => (
                <div
                  key={index}
                  className="text-center group animate-fade-in-up hover-lift p-8 rounded-3xl border border-border bg-gradient-to-b from-card to-accent/30"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="mb-6 flex justify-center">
                      <img
                        src={goal.icon}
                        alt={goal.title}
                        className="w-24 h-24 md:w-24 md:h-24 object-contain"
                        loading="lazy"
                      />
                  </div>
                  <h3 className="mb-4 text-xl md:text-2xl font-semibold">
                    {goal.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {goal.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      <Footer />
    </main>
  );
};

export default AboutPage;
